import $ from 'jquery';
import toastr from 'toastr';

if ($.fn.button) $.fn.btn = $.fn.button.noConflict(); // reverts $.fn.button to jqueryui btn

$(document).ready(function() {
    let reason = $("form select[name=reason]"),
        client = $("form select[name=client]"),
        comment = $("form input[name=comments]");

    client.change(function() {
        if (client.val() == 'Personal') {
            reason.prop("disabled", true);
            comment.prop("disabled", true);
        } else {
            reason.prop("disabled", false);
            comment.prop("disabled", false);
        }
    });
});

/* function for micro cr submit*/
function getValidFormData(form) {
    let client = form.client.options[form.client.selectedIndex].value,
        reason = form.reason.options[form.reason.selectedIndex].value,
        comments = form.comments.value;

    let minutes = Number(form.minutes.value);

    if (window.microCRValidForm({client, reason, comments, minutes})) {
        return {
            'client': client,
            'reason': reason,
            'comments': comments,
            'minutes': minutes.valueOf(),
            'return_url': form.elements.return_url.value
        };
    } else {
        $.unblockUI();
        return false;
    }
}

window.microCRValidForm = function({client, reason, comments, minutes}) {
    if (client.length == 0) {
        alert("Please select a customer for the micro.");
        return false;
    }

    if (isNaN(minutes) || (minutes <= 0)) {
        alert("Please enter the number of minutes spent for the micro.");
        return false;
    }

    if (client != 'Personal' && ((minutes > 15) || (minutes <= 0))) {
        alert("Minutes must be between 0 and 15! You've entered " + minutes + "!");
        return false;
    }

    let needComment = true;
    if ((client == 'Personal')
        || (reason == 'Managing CRs')
        || (reason == 'Page Ack')
        || (reason == 'Dailies')
        || (reason == 'Setting ETAs')) {
        needComment = false;
    }

    if (comments.length == 0 && needComment) {
        alert("You must enter a comment for a " + reason + " Micro CR!");
        return false;
    }

    return true;
};

$('#start-my-day-button').click(function() {
    let $button = $('#start-my-day-button');
    $button.prop('disabled', true);
    $.ajax({
        type: 'POST',
        url: '/track/header/start_my_day',
        dataType: 'json',
        success(response) {
            $button.hide();
            $('#day-started-text').html('Day Started ' + response.local_sod);
            $('#day-started-filler').html('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

            toastr.success('Day started at ' + response.local_sod); // use default toastr options

            if (!window.clocks) return;
            // now, start the clock ticking
            window.clocks.headerTotalUnallocated(response.unbooked_processed.minutes);
        },
        error(req) {
            let res = JSON.parse(req.responseText);
            $button.prop('disabled', false);
            alert(res.error);
        }
    });
});

window.submitMicroCRcb = function(response, client, minutes) {
    toastr.options.timeOut = '10000';
    toastr.options.positionClass = 'toast-bottom-right';

    minutes = minutes.valueOf();

    let textMinutes = minutes > 1 ? 'minutes' : 'minute';

    if (client == 'Personal') {
        toastr.success("Booked " + minutes + " " + textMinutes + " of personal time.");
    } else {
        toastr.success("Booked " + minutes + " " + textMinutes + " to Micro " +
                        "<a href=/track/cr/" + response.micro_p_id + ">CR " + response.micro_p_id + "</a>.");
    }

    $('#personal-minutes').html(response.personal_minutes);
    $('#day-booked').html(response.worked_today);
    $('#total-booked').html(response.total_booked);
    //If clocks is undefined, return
    if (!window.clocks) return;
    // Update Header Timer
    window.clocks.headerTotalUnallocated(response.unbooked_processed.minutes);
    // Update Comment timer (if any)
    if (window.clocks.commentUnallocated) {
        window.clocks.commentUnallocated(0);//since last comment clock in add comment
    }
    if (window.clocks.commentTotalUnallocated) {
        //since start of day clock in add comment
        window.clocks.commentTotalUnallocated(response.unbooked_processed.minutes);
    }
};

window.submitMicroCR = function(form) {
    $.blockUI({
        "css": {
            "font-size": "16pt",
            "padding": "15px"
        },
        "baseZ": 10002,
        "message": "booking time..."
    });

    let data = getValidFormData(form);

    if (!data) {
        $.unblockUI();
        return;
    }

    $.ajax({
        type: 'POST',
        url: '/track/header/micro',
        data: data,
        dataType: 'json',
        success(response) {
            $.unblockUI();

            if (response.reload_page == 1) {
                window.location = form.elements.return_url.value;
            } else {
                let client = form.client.options[form.client.selectedIndex].value;
                let minutes = Number(form.minutes.value);

                window.submitMicroCRcb(response, client, minutes);
                // cleanup
                form.comments.value = '';
                form.minutes.value = '';

                let $client = $(form.client),
                    $reason = $(form.reason);
                $client.val($client.find('option:first').val());
                // if the client was "Personal", the reason dropdown would have been disabled.
                $reason.prop("disabled", false);
                $reason.val($reason.find('option:first').val());
            }
        },
        error(req) {
            let res = JSON.parse(req.responseText);
            $.unblockUI();
            alert(res.error);
        }
    });
};




/** WEBPACK FOOTER **
 ** ./js/app/common/track_header.js
 **/